interface Props {
  name: string
}

const To = ({ name }: Props) => (
  <div className="md:text-right mt-6 md:mt-0">
    <h4 className="font-medium text-neutral-400">To:</h4>
    <dl>
      <dt className="sr-only">company name</dt>
      <dd>{name}</dd>
    </dl>
  </div>
)

export default To
